import { render, staticRenderFns } from "./PopupComfirm.vue?vue&type=template&id=6959c74c&scoped=true"
import script from "./PopupComfirm.vue?vue&type=script&lang=js"
export * from "./PopupComfirm.vue?vue&type=script&lang=js"
import style0 from "./PopupComfirm.vue?vue&type=style&index=0&id=6959c74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959c74c",
  null
  
)

export default component.exports